import _BaseAPIService from "./_BaseAPIService";

const apiService = _BaseAPIService.instance;
const FormService = {
  create: async (data) => {
    const response = await apiService.post("/studentinterestforms", data);
    return response.data;
  },
  createFranchise: async (data) => {
    const response = await apiService.post("/franchiseinquiry", data);
    return response.data;
  },
  getAvailableSlot: async (date ) => {
    const response = await apiService.get(`/appointment/slots?date=${date}`);
    return response.data;
  },
};

export default FormService;
